import React, { useEffect, useState } from "react";
import { FiSave } from "react-icons/fi";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";
import PerfectScrollbar from "react-perfect-scrollbar";
import PageHeaderSetting from "../shared/pageHeader/PageHeaderSetting";
import Footer from "../shared/Footer";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const SettingControlForm = () => {
  const [existing, setExisting] = useState(null);
  const [form, setForm] = useState({
    timeout_duration: "",
    max_upload_size: "",
    max_upload_limit: "",
    max_upload_capacity: "",
    cargo_fee: "",
    cargo_currency_id: "",
  });
  const [currencies, setCurrencies] = useState([]);
  useEffect(() => {
    axios.get(`${BASE_URL}/api/currencies/active`).then((res) => {
      const list = res.data || [];
      setCurrencies(list);

      // DB'de kayıtlı varsa onu kullan
      if (existing?.cargo_currency_id) return;

      // yoksa default seç
      const def = list.find((c) => c.is_default === 1);
      if (def) {
        setForm((prev) => ({
          ...prev,
          cargo_currency_id: def.id,
        }));
      }
    });
  }, [existing]);

  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (k, d) => translations[k] || d;

  /* ⇢ ayarları getir */
  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/settings`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
        },
      })
      .then((r) => {
        setExisting(r.data);
        setForm({
          timeout_duration: r.data.timeout_duration ?? "",
          max_upload_size: r.data.max_upload_size ?? "",
          max_upload_limit: r.data.max_upload_limit ?? "",
          max_upload_capacity: r.data.max_upload_capacity ?? "",
          category_image_width: r.data.category_image_width ?? "",
          category_image_height: r.data.category_image_height ?? "",
          brand_image_width: r.data.brand_image_width ?? "",
          brand_image_height: r.data.brand_image_height ?? "",
          product_list_image_width: r.data.product_list_image_width ?? "",
          product_list_image_height: r.data.product_list_image_height ?? "",
          product_gallery_image_width: r.data.product_gallery_image_width ?? "",
          show_warehouse_stock: r.data.show_warehouse_stock ?? 1,
          product_gallery_image_height:
            r.data.product_gallery_image_height ?? "",
          cargo_fee: r.data.cargo_fee ?? "",
          cargo_currency_id: r.data.cargo_currency_id ?? "",
        });
      })
      .catch((e) => {
        console.error(e);
        toast.error(getText("SETTINGS_FETCH_ERROR"));

      });
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setForm({ ...form, [name]: checked ? 1 : 0 });
      return;
    }
    if (/^\d*$/.test(value)) setForm({ ...form, [name]: value });
  };

  const handleSave = async () => {
    if (!existing) return;

    /*sadece değişen alanları hazırla */
    const dirty = Object.keys(form).reduce((acc, k) => {
      if (String(form[k]) !== String(existing[k])) acc[k] = form[k];
      return acc;
    }, {});

    if (Object.keys(dirty).length === 0) {
      toast.info(getText("NO_CHANGES"));

      return;
    }

    try {
      await axios.put(`${BASE_URL}/api/settings/1`, dirty, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
        },
      });
      toast.success(getText("SETTINGS_SAVED_SUCCESS"));
      setExisting({ ...existing, ...dirty }); // referans güncelle
    } catch (e) {
      console.error(e);
      toast.error(getText("SETTINGS_SAVE_ERROR"));

    }
  };

  if (!existing) return null; // yükleniyor…

  return (
    <div className="content-area setting-form">
      <ToastContainer />
      <PerfectScrollbar>
        <PageHeaderSetting />
        <div className="content-area-body">
          <div className="card">
            <div className="card-body">
              {/* timeout */}

              {/* IMAGE SIZE SETTINGS */}
              <div className="mb-4">
                <h6 className="fw-bold mb-2">{getText("CATEGORY_IMAGE_SIZE_TITLE")}</h6>

                <div className="row mb-2 align-items-center">
                  <div className="col-md-2">
                    <label className="fw-semibold">{getText("WIDTH_LABEL")}</label>
                  </div>
                  <div className="col-md-4">
                    <input
                      type="number"
                      className="form-control"
                      name="category_image_width"
                      value={form.category_image_width || ""}
                      onChange={handleChange}
                      placeholder="ex: 300"
                    />
                  </div>

                  <div className="col-md-2">
                    <label className="fw-semibold">{getText("HEIGHT_LABEL")}</label>
                  </div>
                  <div className="col-md-4">
                    <input
                      type="number"
                      className="form-control"
                      name="category_image_height"
                      value={form.category_image_height || ""}
                      onChange={handleChange}
                      placeholder="ex: 300"
                    />
                  </div>
                </div>
              </div>

              <div className="mb-4">
                <h6 className="fw-bold mb-2">{getText("BRAND_IMAGE_SIZE_TITLE")}</h6>

                <div className="row mb-2 align-items-center">
                  <div className="col-md-2">
                    <label className="fw-semibold">{getText("WIDTH_LABEL")}</label>
                  </div>
                  <div className="col-md-4">
                    <input
                      type="number"
                      className="form-control"
                      name="brand_image_width"
                      value={form.brand_image_width || ""}
                      onChange={handleChange}
                      placeholder="Örn: 200"
                    />
                  </div>

                  <div className="col-md-2">
                    <label className="fw-semibold">{getText("HEIGHT_LABEL")}</label>
                  </div>
                  <div className="col-md-4">
                    <input
                      type="number"
                      className="form-control"
                      name="brand_image_height"
                      value={form.brand_image_height || ""}
                      onChange={handleChange}
                      placeholder="Örn: 200"
                    />
                  </div>
                </div>
              </div>

              <div className="mb-4">
                <h6 className="fw-bold mb-2">{getText("PRODUCT_LIST_IMAGE_SIZE_TITLE")}</h6>

                <div className="row mb-2 align-items-center">
                  <div className="col-md-2">
                    <label className="fw-semibold">{getText("WIDTH_LABEL")}</label>
                  </div>
                  <div className="col-md-4">
                    <input
                      type="number"
                      className="form-control"
                      name="product_list_image_width"
                      value={form.product_list_image_width || ""}
                      onChange={handleChange}
                      placeholder="Örn: 400"
                    />
                  </div>

                  <div className="col-md-2">
                    <label className="fw-semibold">{getText("HEIGHT_LABEL")}</label>
                  </div>
                  <div className="col-md-4">
                    <input
                      type="number"
                      className="form-control"
                      name="product_list_image_height"
                      value={form.product_list_image_height || ""}
                      onChange={handleChange}
                      placeholder="Örn: 400"
                    />
                  </div>
                </div>
              </div>

              <div className="mb-4">
                <h6 className="fw-bold mb-2">{getText("PRODUCT_GALLERY_IMAGE_SIZE_TITLE")}</h6>

                <div className="row mb-2 align-items-center">
                  <div className="col-md-2">
                    <label className="fw-semibold">{getText("WIDTH_LABEL")}</label>
                  </div>
                  <div className="col-md-4">
                    <input
                      type="number"
                      className="form-control"
                      name="product_gallery_image_width"
                      value={form.product_gallery_image_width || ""}
                      onChange={handleChange}
                      placeholder="Örn: 800"
                    />
                  </div>

                  <div className="col-md-2">
                    <label className="fw-semibold">{getText("HEIGHT_LABEL")}</label>
                  </div>
                  <div className="col-md-4">
                    <input
                      type="number"
                      className="form-control"
                      name="product_gallery_image_height"
                      value={form.product_gallery_image_height || ""}
                      onChange={handleChange}
                      placeholder="Örn: 800"
                    />
                  </div>
                </div>
              </div>
              {/* Kargo Ücreti */}
              <div className="mb-4">
                <h6 className="fw-bold mb-2">{getText("CARGO_SETTINGS_TITLE")}</h6>

                <div className="row mb-2 align-items-center">
                  <div className="col-md-4">
                    <label className="fw-semibold">
                      {getText("DEFAULT_CARGO_FEE_LABEL")}
                    </label>
                  </div>

                  <div className="col-md-4">
                    <div className="input-group">
                      <input
                        type="number"
                        step="0.01"
                        min="0"
                        className="form-control"
                        name="cargo_fee"
                        value={form.cargo_fee || ""}
                        onChange={(e) =>
                          setForm({
                            ...form,
                            cargo_fee: e.target.value,
                          })
                        }
                        placeholder="ex: 49.90"
                      />
                      <select
                        className="form-select"
                        style={{ maxWidth: "120px" }}
                        name="cargo_currency_id"
                        value={form.cargo_currency_id}
                        onChange={handleChange}
                      >
                        <option value="">Para</option>
                        {currencies.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.code}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-4">
                <h6 className="fw-bold mb-2">{getText("WAREHOUSE_SETTINGS_TITLE")}</h6>

                <div className="row mb-2 align-items-center">
                  <div className="col-md-4">
                    <label className="fw-semibold">
                     {getText("SHOW_WAREHOUSE_STOCK_LABEL")}
                    </label>
                  </div>

                  <div className="col-md-8">
                    <div className="form-check form-switch">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="showWarehouseStockSwitch"
                        name="show_warehouse_stock"
                        checked={form.show_warehouse_stock == 1}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-center mt-4">
                <button className="btn btn-primary" onClick={handleSave}>
                  <FiSave className="me-2" />
                  {getText("SAVE_BTN")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </PerfectScrollbar>
    </div>
  );
};

export default SettingControlForm;
